import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { ClientReferralTask } from '../../../core/models/client-referral-task.model';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { TaskStatusPipe } from '../../../shared/pipes/task-status.pipe';
import { ClaimSourcePipe } from '../../../shared/pipes/claim-source.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-client-referral-task-list',
    templateUrl: './client-referral-task-list.component.html',
    styleUrls: ['./client-referral-task-list.component.scss'],
    imports: [PaginationHeaderComponent,
              RouterLink,
              PrescriberNameComponent,
              ExpirationDateComponent,
              PaginationComponent,
              DecimalPipe,
              CurrencyPipe,
              DatePipe,
              TaskStatusPipe,
              ClaimSourcePipe,
              BlankValueDashPipe]
})
export class ClientReferralTaskListComponent {
  @Input() tasks: ClientReferralTask[];
  @Input() paging: LimitOffsetPaging;

  @Output() public pageChange = new EventEmitter<number>();
  @Output() public pageSizeChange = new EventEmitter<number>();

  constructor() {}

  onPageChange(page) {
    this.pageChange.emit(page);
  }

  onPageSizeChange(size) {
    this.pageSizeChange.emit(size);
  }
}
